export default __webpack_public_path__ + "static/media/Back.fc3089ca.svg";